import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { TrendingUp, ArrowRight } from 'lucide-react';

export default function BreakoutSkuList({ products }) {
  const navigate = useNavigate();
  
  return (
    <Card style={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', overflow: 'hidden' }}>
      <CardHeader style={{ padding: '1.5rem', borderBottom: '1px solid hsl(var(--border))' }}>
        <CardTitle className="text-base flex items-center gap-2">
          <TrendingUp size={20} style={{ color: '#2EE6A6' }} />
          Breakout SKUs
        </CardTitle>
      </CardHeader>
      
      <CardContent className="p-0">
        {products.map((product, idx) => (
          <div
            key={product.id}
            onClick={() => navigate(`/commerce/product/${product.id}`)}
            style={{
              padding: '1.5rem',
              borderBottom: idx < products.length - 1 ? '1px solid hsl(var(--border))' : 'none',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background 0.2s ease'
            }}
            className="hover:bg-[#152030]"
          >
            <div style={{ flex: 1 }}>
              <div style={{ 
                fontSize: '0.875rem', 
                fontWeight: 500,
                color: 'hsl(var(--foreground))',
                marginBottom: 4
              }}>
                {product.name}
              </div>
              <div style={{ fontSize: '0.75rem', color: 'hsl(var(--muted-foreground))' }}>
                {product.category}
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <div style={{ textAlign: 'right' }}>
                <div style={{ 
                  fontSize: '1.125rem', 
                  fontWeight: 700,
                  fontFamily: 'monospace',
                  color: 'hsl(var(--success))'
                }}>
                  +{product.velocity.toFixed(1)}%
                </div>
                <div style={{ fontSize: '0.6875rem', color: 'hsl(var(--muted-foreground))' }}>
                  Score {Math.round(product.compositeScore * 100)}
                </div>
              </div>
              <ArrowRight size={16} style={{ color: 'hsl(var(--muted-foreground))' }} />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
